<template>
  <div class="center-beam w-full"></div>
</template>

<script>
import { TweenMax, TimelineMax } from "gsap";

const ANIMATION_SPEED = 2;

export default {
  name: "CenterBeam",
  mounted() {
    TweenMax.to(this.$el, 3, {
      scaleX: "1.1",
      yoyo: true,
      repeat: -1
    });

    const tl = new TimelineMax({ repeat: -1, yoyo: true });

    tl.to(this.$el, 1, {
      boxShadow: "0px 0px 15px rgba(0, 193, 252, 1)"
    });

    tl.to(this.$el, 1, {
      boxShadow: "2px 2px 30px rgba(0, 193, 252, 1)"
    });
  }
};
</script>

<style lang="scss">
.center-beam {
  border-radius: 0px 20px 20px 0px;
  background: rgba(0, 193, 252, 1);
}
</style>